import { render, staticRenderFns } from "./statusOdontogramaSetting.vue?vue&type=template&id=e5be1100"
import script from "./statusOdontogramaSetting.vue?vue&type=script&lang=js"
export * from "./statusOdontogramaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports